module.exports = __webpack_public_path__ + "media/images/banner-2-50b3feb846e11cf50105ea0b31934dcb.jpg";